export const VisibilityDict = {
  visible: 'Ορατό στο κοινό',
  hidden: 'Μη Ορατό στο κοινό',
  sample: 'Ενδεικτικο'
};

export enum VisibilityEnum {
  Visible = 'visible',
  Hidden = 'hidden',
  Sample = 'sample'
}